"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var array_data_source_1 = require("../../collections/array-data-source");
var data_source_1 = require("../../collections/data-source");
var coercion_1 = require("@angular/cdk/coercion");
var operators_1 = require("rxjs/operators");
var sis_virtual_scroll_viewport_component_1 = require("../virtual-scroll-viewport/sis-virtual-scroll-viewport.component");
var of_1 = require("rxjs/observable/of");
var view_repeater_1 = require("../../collections/view-repeater");
var recycle_view_repeater_strategy_1 = require("../../collections/recycle-view-repeater-strategy");
var Observable_1 = require("rxjs/Observable");
var Subject_1 = require("rxjs/Subject");
/** Helper to extract the offset of a DOM Node in a certain direction. */
function getOffset(orientation, direction, node) {
    var el = node;
    if (!el.getBoundingClientRect) {
        return 0;
    }
    var rect = el.getBoundingClientRect();
    if (orientation === 'horizontal') {
        return direction === 'start' ? rect.left : rect.right;
    }
    return direction === 'start' ? rect.top : rect.bottom;
}
/**
 * Returns true if the object is a function.
 * @param value The value to check
 */
function isFunction(value) {
    return typeof value === 'function';
}
exports.isFunction = isFunction;
/**
 * Tests to see if the object is an RxJS {@link Observable}
 * @param obj the object to test
 */
function isObservable(obj) {
    // The !! is to ensure that this publicly exposed function returns
    // `false` if something like `null` or `0` is passed.
    return !!obj && (obj instanceof Observable_1.Observable || (isFunction(obj.lift) && isFunction(obj.subscribe)));
}
exports.isObservable = isObservable;
/**
 * A directive similar to `ngForOf` to be used for rendering data inside a virtual scrolling
 * container.
 */
var SisVirtualForOf = /** @class */ (function () {
    function SisVirtualForOf(
        /** The view container to add items to. */
        _viewContainerRef, 
        /** The template to use when stamping out new items. */
        _template, 
        /** The set of available differs. */
        _differs, 
        /** The strategy used to render items in the virtual scroll viewport. */
        _viewRepeater, 
        /** The virtual scrolling viewport that these items are being rendered in. */
        _viewport, ngZone) {
        var _this = this;
        this._viewContainerRef = _viewContainerRef;
        this._template = _template;
        this._differs = _differs;
        this._viewRepeater = _viewRepeater;
        this._viewport = _viewport;
        /** Emits when the rendered view of the data changes. */
        this.viewChange = new Subject_1.Subject();
        /** Subject that emits when a new DataSource instance is given. */
        this._dataSourceChanges = new Subject_1.Subject();
        /** Emits whenever the data in the current DataSource changes. */
        this.dataStream = this._dataSourceChanges
            .pipe(
        // Start off with null `DataSource`.
        operators_1.startWith(null), 
        // Bundle up the previous and current data sources so we can work with both.
        operators_1.pairwise(), 
        // Use `_changeDataSource` to disconnect from the previous data source and connect to the
        // new one, passing back a stream of data changes which we run through `switchMap` to give
        // us a data stream that emits the latest data from whatever the current `DataSource` is.
        operators_1.switchMap(function (_a) {
            var prev = _a[0], cur = _a[1];
            return _this._changeDataSource(prev, cur);
        }), 
        // Replay the last emitted data when someone subscribes.
        operators_1.shareReplay(1));
        /** The differ used to calculate changes to the data. */
        this._differ = null;
        /** Whether the rendered data should be updated during the next ngDoCheck cycle. */
        this._needsUpdate = false;
        this._destroyed = new Subject_1.Subject();
        this.dataStream.subscribe(function (data) {
            _this._data = data;
            _this._onRenderedDataChange();
        });
        this._viewport.renderedRangeStream.pipe(operators_1.takeUntil(this._destroyed)).subscribe(function (range) {
            _this._renderedRange = range;
            ngZone.run(function () { return _this.viewChange.next(_this._renderedRange); });
            _this._onRenderedDataChange();
        });
        this._viewport.attach(this);
    }
    Object.defineProperty(SisVirtualForOf.prototype, "sisVirtualForOf", {
        /** The DataSource to display. */
        get: function () {
            return this._sisVirtualForOf;
        },
        set: function (value) {
            this._sisVirtualForOf = value;
            if (data_source_1.isDataSource(value)) {
                this._dataSourceChanges.next(value);
            }
            else {
                // If value is an NgIterable, convert it to an array.
                this._dataSourceChanges.next(new array_data_source_1.ArrayDataSource(isObservable(value) ? value : Array.from(value || [])));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisVirtualForOf.prototype, "sisVirtualForTrackBy", {
        /**
         * The `TrackByFunction` to use for tracking changes. The `TrackByFunction` takes the index and
         * the item and produces a value to be used as the item's identity when tracking changes.
         */
        get: function () {
            return this._sisVirtualForTrackBy;
        },
        set: function (fn) {
            var _this = this;
            this._needsUpdate = true;
            this._sisVirtualForTrackBy = fn ?
                function (index, item) { return fn(index + (_this._renderedRange ? _this._renderedRange.start : 0), item); } :
                undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisVirtualForOf.prototype, "sisVirtualForTemplate", {
        /** The template used to stamp out new elements. */
        set: function (value) {
            if (value) {
                this._needsUpdate = true;
                this._template = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisVirtualForOf.prototype, "sisVirtualForTemplateCacheSize", {
        /**
         * The size of the cache used to store templates that are not being used for re-use later.
         * Setting the cache size to `0` will disable caching. Defaults to 20 templates.
         */
        get: function () {
            return this._viewRepeater.viewCacheSize;
        },
        set: function (size) {
            this._viewRepeater.viewCacheSize = coercion_1.coerceNumberProperty(size);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Measures the combined size (width for horizontal orientation, height for vertical) of all items
     * in the specified range. Throws an error if the range includes items that are not currently
     * rendered.
     */
    SisVirtualForOf.prototype.measureRangeSize = function (range, orientation) {
        if (range.start >= range.end) {
            return 0;
        }
        if ((range.start < this._renderedRange.start || range.end > this._renderedRange.end) &&
            (typeof ngDevMode === 'undefined' || ngDevMode)) {
            throw Error("Error: attempted to measure an item that isn't rendered.");
        }
        // The index into the list of rendered views for the first item in the range.
        var renderedStartIndex = range.start - this._renderedRange.start;
        // The length of the range we're measuring.
        var rangeLen = range.end - range.start;
        // Loop over all the views, find the first and land node and compute the size by subtracting
        // the top of the first node from the bottom of the last one.
        var firstNode;
        var lastNode;
        // Find the first node by starting from the beginning and going forwards.
        for (var i = 0; i < rangeLen; i++) {
            var view = this._viewContainerRef.get(i + renderedStartIndex);
            if (view && view.rootNodes.length) {
                firstNode = lastNode = view.rootNodes[0];
                break;
            }
        }
        // Find the last node by starting from the end and going backwards.
        for (var i = rangeLen - 1; i > -1; i--) {
            var view = this._viewContainerRef.get(i + renderedStartIndex);
            if (view && view.rootNodes.length) {
                lastNode = view.rootNodes[view.rootNodes.length - 1];
                break;
            }
        }
        return firstNode && lastNode ?
            getOffset(orientation, 'end', lastNode) - getOffset(orientation, 'start', firstNode) : 0;
    };
    SisVirtualForOf.prototype.ngDoCheck = function () {
        if (this._differ && this._needsUpdate) {
            var changes = this._differ.diff(this._renderedItems);
            if (!changes) {
                this._updateContext();
            }
            else {
                this._applyChanges(changes);
            }
            this._needsUpdate = false;
        }
    };
    SisVirtualForOf.prototype.ngOnDestroy = function () {
        this._viewport.detach();
        this._dataSourceChanges.next(undefined);
        this._dataSourceChanges.complete();
        this.viewChange.complete();
        this._destroyed.next();
        this._destroyed.complete();
        this._viewRepeater.detach();
    };
    /** React to scroll state changes in the viewport. */
    SisVirtualForOf.prototype._onRenderedDataChange = function () {
        if (!this._renderedRange) {
            return;
        }
        this._renderedItems = this._data.slice(this._renderedRange.start, this._renderedRange.end);
        if (!this._differ) {
            this._differ = this._differs.find(this._renderedItems).create(this.sisVirtualForTrackBy);
        }
        this._needsUpdate = true;
    };
    /** Swap out one `DataSource` for another. */
    SisVirtualForOf.prototype._changeDataSource = function (oldDs, newDs) {
        if (oldDs) {
            oldDs.disconnect(this);
        }
        this._needsUpdate = true;
        return newDs ? newDs.connect(this) : of_1.of();
    };
    /** Update the `SisVirtualForOfContext` for all views. */
    SisVirtualForOf.prototype._updateContext = function () {
        var count = this._data.length;
        var i = this._viewContainerRef.length;
        while (i--) {
            var view = this._viewContainerRef.get(i);
            view.context.index = this._renderedRange.start + i;
            view.context.count = count;
            this._updateComputedContextProperties(view.context);
            view.detectChanges();
        }
    };
    /** Apply changes to the DOM. */
    SisVirtualForOf.prototype._applyChanges = function (changes) {
        var _this = this;
        this._viewRepeater.applyChanges(changes, this._viewContainerRef, function (record, adjustedPreviousIndex, currentIndex) { return _this._getEmbeddedViewArgs(record, currentIndex); }, function (record) { return record.item; });
        // Update $implicit for any items that had an identity change.
        changes.forEachIdentityChange(function (record) {
            var view = _this._viewContainerRef.get(record.currentIndex);
            view.context.$implicit = record.item;
        });
        // Update the context variables on all items.
        var count = this._data.length;
        var i = this._viewContainerRef.length;
        while (i--) {
            var view = this._viewContainerRef.get(i);
            view.context.index = this._renderedRange.start + i;
            view.context.count = count;
            this._updateComputedContextProperties(view.context);
        }
    };
    /** Update the computed properties on the `SisVirtualForOfContext`. */
    SisVirtualForOf.prototype._updateComputedContextProperties = function (context) {
        context.first = context.index === 0;
        context.last = context.index === context.count - 1;
        context.even = context.index % 2 === 0;
        context.odd = !context.even;
    };
    SisVirtualForOf.prototype._getEmbeddedViewArgs = function (record, index) {
        // Note that it's important that we insert the item directly at the proper index,
        // rather than inserting it and the moving it in place, because if there's a directive
        // on the same node that injects the `ViewContainerRef`, Angular will insert another
        // comment node which can throw off the move when it's being repeated for all items.
        return {
            templateRef: this._template,
            context: {
                $implicit: record.item,
                // It's guaranteed that the iterable is not 'undefined' or 'null' because we only
                // generate views for elements if the 'sisVirtualForOf' iterable has elements.
                sisVirtualForOf: this._sisVirtualForOf,
                index: -1,
                count: -1,
                first: false,
                last: false,
                odd: false,
                even: false
            },
            index: index,
        };
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], SisVirtualForOf.prototype, "sisVirtualForOf", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Function])
    ], SisVirtualForOf.prototype, "sisVirtualForTrackBy", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", core_1.TemplateRef),
        __metadata("design:paramtypes", [core_1.TemplateRef])
    ], SisVirtualForOf.prototype, "sisVirtualForTemplate", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Number])
    ], SisVirtualForOf.prototype, "sisVirtualForTemplateCacheSize", null);
    SisVirtualForOf = __decorate([
        core_1.Directive({
            selector: '[sisVirtualFor][sisVirtualForOf]',
            providers: [
                { provide: view_repeater_1._VIEW_REPEATER_STRATEGY, useClass: recycle_view_repeater_strategy_1._RecycleViewRepeaterStrategy },
            ]
        }),
        __param(3, core_1.Inject(view_repeater_1._VIEW_REPEATER_STRATEGY)),
        __param(4, core_1.SkipSelf()),
        __metadata("design:paramtypes", [core_1.ViewContainerRef,
            core_1.TemplateRef,
            core_1.IterableDiffers,
            recycle_view_repeater_strategy_1._RecycleViewRepeaterStrategy,
            sis_virtual_scroll_viewport_component_1.SisVirtualScrollViewportComponent,
            core_1.NgZone])
    ], SisVirtualForOf);
    return SisVirtualForOf;
}());
exports.SisVirtualForOf = SisVirtualForOf;
//# sourceMappingURL=virtual-for-of.js.map